import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, FilterIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const buttonCss = "bd2zzba";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
const filtersAppliedCss = "fe4apkm";
const FiltersApplied = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filtersAppliedCss, props.className)} />;
});
const filterCountCss = "feg2o49";
const FilterCount = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(filterCountCss, props.className)} />;
});
const filterIconContainerCss = "f31i7d9";
const FilterIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(filterIconContainerCss, props.className)} />;
});
const IconContainer = ({
  filterCount,
  isModalOpen
}) => {
  if (filterCount > 0) return null;
  if (isModalOpen) return <ArrowChevronUpMiniIcon />;
  return <ArrowChevronDownMiniIcon />;
};
export const FilterButton = forwardRef(({
  isModalOpen,
  openModal,
  closeModal,
  filterCount
}, ref) => {
  const isDesktopUp = useDeviceType('isDesktopUp');
  const handleClick = () => {
    if (isModalOpen) {
      closeModal();
    } else {
      openModal();
    }
  };
  return <Button ref={ref} aria-label={I18n.t('publisher.event_types.filter')} onClick={handleClick}>
      <FilterIconContainer>
        <FilterIcon />
      </FilterIconContainer>
      {isDesktopUp && <>
          {I18n.t('publisher.event_types.filter')}
          <IconContainer filterCount={filterCount} isModalOpen={isModalOpen} />
        </>}
      {filterCount > 0 && <FiltersApplied>
          <FilterCount>{filterCount}</FilterCount>
        </FiltersApplied>}
    </Button>;
});

require("./filter_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");